import React from 'react'
import { Outlet } from "react-router-dom";

const LayoutContainer = () => { 
  return ( 
    <div className="blank_layout_wrapper">
        <Outlet />
    </div> 
  )
}

export default LayoutContainer